import React from 'react';
import classes from './DoubleLargeImage.module.scss';
import cx from 'classnames';

const DoubleLargeImage = ({ image1, imageLink1, image2, imageLink2 }: any) => {
  return (
    <div className={cx(classes.imageContainer, 'container')}>
      <div className={classes.image}>
        <a {...(imageLink1 !== null && { href: imageLink1.Url })} target='_blank'>
          <img className='rounded img-fluid' height='auto' width='100%' src={image1.umbracoFile} alt='' />
        </a>
      </div>
      <div className={classes.image}>
        <a {...(imageLink2 !== null && { href: imageLink2.Url })} target='_blank'>
          <img className='rounded img-fluid' height='auto' width='100%' src={image2.umbracoFile} alt='' />
        </a>
      </div>
    </div>
  );
};

export default DoubleLargeImage;
